import script from "./sub-device-form-drawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./sub-device-form-drawer.vue?vue&type=script&lang=ts&setup=true"

import "./sub-device-form-drawer.vue?vue&type=style&index=0&id=210649e5&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-210649e5"]])

export default __exports__